import { environment } from '../../../environments/environment';

/**
 * AppSettings class - Central configuration management
 * 
 * This class now reads from environment files instead of hardcoded values.
 * To build for different environments:
 * - Local: ng serve (or ng build)
 * - Beta: ng build --configuration=beta
 * - Production: ng build --configuration=production
 * 
 * All environment-specific values are now managed in:
 * - src/environments/environment.ts (local)
 * - src/environments/environment.beta.ts (beta/staging)
 * - src/environments/environment.prod.ts (production)
 */
export class AppSettings {
  
  // App Information
  public static get APP_NAME(): string {
    return environment.appName;
  }
  
  public static get CLIENT_VERSION(): string {
    return environment.clientVersion;
  }
  
  public static get PING(): string {
    return environment.pingUrl;
  }
  
  // API Configuration
  public static get HOST(): string {
    return environment.apiHost;
  }
  
  public static get SERVER(): string {
    return this.HOST + environment.apiBasePath;
  }
  
  public static get SERVER_AUTH(): string {
    return this.HOST + environment.authPath;
  }
  
  // OAuth Configuration
  public static get SERVER_CLIENT_ID(): string {
    return environment.clientId;
  }
  
  public static get SERVER_CLIENT_SECRET(): string {
    return environment.clientSecret;
  }
  
  // Session & Authentication (from localStorage)
  public static get SESSION(): string {
    return localStorage.getItem(environment.storageKeys.loginSession);
  }
  
  public static get USER_AUTH(): string {
    return localStorage.getItem(environment.storageKeys.loginAuth);
  }
  
  // Regional Configuration
  public static get COUNTRY_ORIGIN(): string {
    return environment.countryOrigin;
  }
  
  // Storage Keys
  public static get LOCAL_MESSAGE_STORAGE_KEY(): string {
    return environment.storageKeys.messageContents;
  }
  
  public static get LOCAL_MESSAGE_SUMMARY_STORAGE_KEY(): string {
    return environment.storageKeys.messageSummary;
  }
  
  public static get USER_FOREIGN_CHARGES_STORAGE_KEY(): string {
    return environment.storageKeys.foreignCharges;
  }
  
  // Payment Gateway Identifiers
  public static get PAYMENT_GATEWAY_SLYDEPAY(): string {
    return environment.paymentGateways.slydepay;
  }
  
  public static get PAYMENT_GATEWAY_FLUTTERWAVE(): string {
    return environment.paymentGateways.flutterwave;
  }
  
  public static get PAYMENT_GATEWAY_PAYSTACK(): string {
    return environment.paymentGateways.paystack;
  }
  
  public static get PAYMENT_GATEWAY_PAYSTACK_DIRECT(): string {
    return environment.paymentGateways.paystackDirect;
  }
  
  public static get PAYMENT_GATEWAY_MOOLRE_DIRECT(): string {
    return environment.paymentGateways.moolreDirect;
  }
  
  // Paystack Configuration
  public static get PAYSTACK_PUBLIC_KEY(): string {
    return environment.paystackPublicKey;
  }
  
  // MTN MOMO Configuration
  public static get MTN_MOMO_RECIPIENT(): string {
    return environment.mtnMomoRecipient;
  }
  
  // Legacy compatibility methods (deprecated - kept for backward compatibility)
  // These are no longer used but kept to avoid breaking existing code
  /**
   * @deprecated Use environment.apiHost directly instead
   */
  public static get LOCAL_HOST(): string {
    return 'http://localhost:8880';
  }
  
  /**
   * @deprecated Use environment.apiHost directly instead
   */
  public static get BETA_HOST(): string {
    return 'https://testapi.giantsms.com';
  }
  
  /**
   * @deprecated Use environment.apiHost directly instead
   */
  public static get SERVER_HOST(): string {
    return 'https://api.giantsms.com';
  }
}
